import React from "react"
import styled from '~/ui/styled'
import { Avatar } from "~widgets/avatar"
import { Name } from "~components/text"
import { useStores, User } from "../../models"
import { observer } from "mobx-react-lite"
import { OnlineStatus } from "~widgets/online-status"

const Container = styled.Pressable`
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.space.md};
`

const Row = styled.View`
  align-items: center;
  flex-direction: row;
`
const Username = ({ username }) => <SmallText>@{username}</SmallText>

const UserInfo = ({ name, username }) => (
  <Row>
    <Name name={name} />
    <Username username={username} />
  </Row>
)

interface Props {
  user: User
  onSelect: (item: User) => void
}

const Main = styled.View`
  flex-grow: 1;
  margin-left: 10px;
  border-bottom-width: 1px;
  border-color: #e3e6ec;
`

const SmallText = styled.Text`
  font-size: 14px;
  color: #ababab;
`

export const MentionListItem: React.FC<Props> = ({ user, onSelect }) => {
  const { userStore } = useStores()
  const displayName = userStore.getDisplayNameByUser(user)
  return (
    <Container onClick={() => onSelect(user)}>
      <Avatar avatar={user.avatar} name={displayName} />
      <Main>
        <UserInfo name={displayName} username={user.username} />
        <OnlineStatus last_seen={user.last_seen} online={user.online} />
      </Main>
    </Container>
  )
}

export default observer(MentionListItem)
